module.exports = __webpack_public_path__ + "img/mondelez.bc93af51.svg";